/**
 * External dependencies
 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import FormRadio from 'components/forms/form-radio';
import FormLabel from 'components/forms/form-label';

/**
 * Style dependencies
 */
import './styles.scss';

const FormRadioWithThumbnail = ({ label, thumbnail, checked, ...otherProps }) => {
	const { cssClass, cssColor, imageUrl, imageComponent } = thumbnail;

	const classes = classnames('form-radio-with-thumbnail', { checked });
	return (
		<div className={classes}>
			<FormLabel>
				<div
					className={classnames('form-radio-with-thumbnail__thumbnail', cssClass)}
					style={{ backgroundColor: cssColor }}
				>
					{imageUrl && <img src={imageUrl} alt={label} />}
					{imageComponent && imageComponent}
				</div>
				<FormRadio checked={checked} {...otherProps} />
			</FormLabel>
		</div>
	);
};

FormRadioWithThumbnail.propTypes = {
	label: PropTypes.string.isRequired,
	thumbnail: PropTypes.object.isRequired,
};

export default FormRadioWithThumbnail;
